import { Table, Tabs, Tag } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getTenderDetails } from "../../redux/ApplicationSlice";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  IssuesCloseOutlined,
} from "@ant-design/icons";
import "./MobileTenderTable.scss";
import { useTranslation } from "react-i18next";

const MobileTenderTable = () => {
  const { t } = useTranslation();
  const columns = [
    {
      title: t("title"),
      dataIndex: `tender_name`,
      width: "40%",
    },
    {
      title: "",
      dataIndex: `tender_info`,
    },
  ];

  const dispatch = useDispatch();
  const tenders = useSelector((state) => state.application.tenders);

  return (
    <div className={"mobile_tender"}>
      <Tabs defaultActiveKey="1" type="card">
        <TabPane tab={t("active")} key="1">
          <Table
            bordered
            pagination={false}
            columns={columns}
            className={"mobile_tender_table"}
            dataSource={
              Array.isArray(tenders) &&
              tenders
                ?.filter((el) => el?.status === "Актуальный")
                ?.map((it, index) => ({
                  number: <div className={"mobile_td"}>{index + 1}</div>,
                  tender_name: (
                    <Link
                      to={`/tenders/${it.id}`}
                      className={"mobile_tender_name"}
                      onClick={() => dispatch(getTenderDetails(it.id))}
                    >
                      {it?.title}
                    </Link>
                  ),
                  tender_info: (
                    <div>
                      <div className="tender_item">
                        <div className="item_title">{t("number")}:</div>
                        <div className="item_value">№ {it?.tender_no}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("category")}:</div>
                        <div className="item_value">{it?.category?.name}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("published")}:</div>
                        <div className="item_value">{it?.published_date}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("deadline")}:</div>
                        <div className="item_value">{it?.deadline}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("type")}:</div>{" "}
                        <div className="item_value">
                          {it?.announcement_type}
                        </div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("status")}:</div>{" "}
                        <div className="item_value">
                          <Tag color="#7eca8f" className="mobile_tag">
                            <CheckCircleOutlined />
                            &nbsp;{t("Актуальный")}
                          </Tag>
                        </div>
                      </div>
                    </div>
                  ),
                }))
            }
          />
        </TabPane>
        <TabPane tab={t("results")} key="2">
          <Table
            bordered
            pagination={false}
            columns={columns}
            className={"mobile_tender_table"}
            dataSource={
              Array.isArray(tenders) &&
              tenders
                .filter((el) => el.status === "Итоги")
                .map((it, index) => ({
                  number: <div className={"mobile_td"}>{index + 1}</div>,
                  tender_name: (
                    <Link
                      to={`/tenders/${it.id}`}
                      className={"mobile_tender_name"}
                      onClick={() => dispatch(getTenderDetails(it.id))}
                    >
                      {it?.title}
                    </Link>
                  ),
                  tender_info: (
                    <div>
                      <div className="tender_item">
                        <div className="item_title">{t("number")}:</div>
                        <div className="item_value">{it?.tender_no}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("category")}:</div>
                        <div className="item_value">{it?.category?.name}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("published")}:</div>
                        <div className="item_value">{it?.published_date}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("deadline")}:</div>
                        <div className="item_value">{it?.deadline}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("type")}:</div>
                        <div className="item_value">
                          {it?.announcement_type}
                        </div>
                      </div>

                      <div className="tender_item">
                        <div className="item_title">{t("status")}:</div>{" "}
                        <div className="item_value">
                          <Tag
                            color="rgba(239, 91, 91, 0.927)"
                            className="mobile_tag"
                          >
                            <ExclamationCircleOutlined />
                            &nbsp;{t("results")}
                          </Tag>
                        </div>
                      </div>
                    </div>
                  ),
                }))
            }
          />
        </TabPane>
        <TabPane tab={t("completed")} key="3">
          <Table
            bordered
            pagination={false}
            columns={columns}
            className={"mobile_tender_table"}
            dataSource={
              Array.isArray(tenders) &&
              tenders
                .filter((el) => el.status === "Завершен")
                .map((it, index) => ({
                  number: <div className={"mobile_td"}>{index + 1}</div>,
                  tender_name: (
                    <Link
                      to={`/tenders/${it.id}`}
                      className={"mobile_name"}
                      onClick={() => dispatch(getTenderDetails(it.id))}
                    >
                      {it?.title}
                    </Link>
                  ),
                  tender_info: (
                    <div>
                      <div className="tender_item">
                        <div className="item_title">{t("number")}:</div>
                        <div className="item_value">{it?.tender_no}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("category")}:</div>
                        <div className="item_value">{it?.category?.name}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("published")}:</div>
                        <div className="item_value">{it?.published_date}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("deadline")}:</div>
                        <div className="item_value">{it?.deadline}</div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("type")}:</div>{" "}
                        <div className="item_value">
                          {it?.announcement_type}
                        </div>
                      </div>
                      <div className="tender_item">
                        <div className="item_title">{t("status")}:</div>{" "}
                        <div className="item_value">
                          <Tag color="#82c9d5" className="mobile_tag">
                            <IssuesCloseOutlined />
                            &nbsp;{t("completed")}
                          </Tag>
                        </div>
                      </div>
                    </div>
                  ),
                }))
            }
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default MobileTenderTable;
